'use client';

import { Benefits } from '@/features/login/components/benefits/benefits';
import { ConsentsSection } from '@/features/login/components/consents-section/consents-section';
import { LoginMethods } from '@/features/login/components/login-methods/login-methods';
import { useRemoveCookie } from '@/hooks/use-cookies';
import { useRouter } from '@/navigation';
import { Cookie, SessionStorage } from '@/types/storage';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

interface Props {
  clearToken: boolean;
  onSuccessfullyLogin: string | undefined;
}

export default function Login({ clearToken, onSuccessfullyLogin }: Props) {
  const successLoginReturnUrl = onSuccessfullyLogin;
  const t = useTranslations('login');
  const router = useRouter();
  const searchParams = useSearchParams();
  const removeCookie = useRemoveCookie();

  useEffect(() => {
    if (clearToken) {
      removeCookie(Cookie.LOGIN_SECRET);
      removeCookie(Cookie.JUST_LOGGED_IN);
      removeCookie(Cookie.CUSTOMER_TYPE);

      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('clearToken');

      router.replace(`/login?${newSearchParams.toString()}`, {
        scroll: false,
      });
    }
  }, [clearToken, router, searchParams]);

  useEffect(() => {
    if (typeof sessionStorage != 'undefined' && successLoginReturnUrl) {
      sessionStorage.setItem(
        SessionStorage.ON_SUCCESSFULLY_LOGIN,
        decodeURIComponent(successLoginReturnUrl),
      );
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete(SessionStorage.ON_SUCCESSFULLY_LOGIN);
      router.replace(`/login?${newSearchParams.toString()}`, { scroll: false });
    }
  }, [successLoginReturnUrl, router, searchParams]);

  return (
    <div className="flex flex-col items-center px-xs pb-[144px]">
      <p className="py-inner text-heading-l text-strong">{t('title')}</p>
      <Benefits />
      <div className="max-w-max-button-width">
        <LoginMethods />
        <ConsentsSection />
      </div>
    </div>
  );
}
